import getTranslationData from "../../TranslationUtility/TranslationUtility.js";
import usePurchaseLimit from "../Card/hooks/usePurchaseLimit";

/* Remaining purchase limit for the product, shown as a right-aligned pill.
   Used on clients still on the original product detail layout; the newer
   attribute grid renders the same figure as one of its cells. */
const PurchaseLimitPill = () => {
  const translation = getTranslationData();
  const { hasLimit, remaining } = usePurchaseLimit();

  if (!hasLimit) {
    return <></>;
  }

  return (
    <>
      <span className="redm-type text-end">
        {translation?.rem_limit_heading}
      </span>
      <div className="d-flex justify-content-end">
        <span className="redeem-amont-pill">₹{remaining}</span>
      </div>
    </>
  );
};

export default PurchaseLimitPill;
